// import React from "react";
// import SubChapterCard from "../SubChapterCard";
// import {getData, manageData} from "../../requests/CRUD";
// import {getBase64, sortArray} from "../../utils";
// import Icon from "../Icon";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {TRAINING} from "../../consts/tables";
// import {existingFileError, existingFileErrorMessage, missingFileError, videoImage} from "../../consts/consts";
// import { removeFile, uploadFile } from "../../requests/fileRequests";
// import isEqual from "lodash.isequal";

// let cloneDeep = require('lodash.clonedeep');

// const FOLDER = 'training'
// export default class ChapterPage extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             originalChapters: [],
//             chapters: [],
//             title: '',
//             hasVideo: false,
//             videoLink: '',
//             backButton: '',
//             isEdit: false,
//             newChapter: {visible:false},
//             uploadedImage: null,
//             error: null,
//             lastModified: null,
//             previousIndexes: []
//         };

//         this.toggleEdit = this.toggleEdit.bind(this);
//         this.handleInputChange = this.handleInputChange.bind(this);
//         this.handleInputBlur = this.handleInputBlur.bind(this);
//         this.cancelChanges = this.cancelChanges.bind(this);
//         this.saveChanges = this.saveChanges.bind(this);
//         this.validateSelectedFile = this.validateSelectedFile.bind(this);
//         this.uploadPhoto = this.uploadPhoto.bind(this);
//         this.removePhoto = this.removePhoto.bind(this);
//         this.deleteCard =  this.deleteCard.bind(this);
//     }

//     componentDidMount() {
//         this.fetch(this.props.params);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
//             this.fetch(nextProps.params);
//     }

//     toggleEdit() {
//         this.setState(prevState => {
//             return {
//                 isEdit: !prevState.isEdit
//             }
//         });
//     }

//     getNewSlug(title){
//         return title.toString().toLowerCase()
//                 .replace(/[&]/g,'and')              //replace '&' with 'and'
//                 .replace(/<br\/>|\s(-|\/)\s/g,'')  // remove ' - ', ' / ', '</br>'
//                 .replace(/[^\w\s\/\-]/g, '')        //replace punctuation characters except '/' and '-'
//                 .replace(/[\/ ]/g, "-");            //replace ' ' and '/' with '-'
//     }

//     saveChanges() { 
//         const params = this.props.params;
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');

//         const chapters = cloneDeep(this.state.chapters);

//         const newChapter = cloneDeep(this.state.newChapter);
//         let chapterToSave = {};
//         if (newChapter && newChapter.visible) {
//             const maxIndex = chapters.length ? Math.max(...chapters.map(ch => ch.index)) + 1 : 1;
//             let newChapterSlug = this.getNewSlug(newChapter.title);
//             chapterToSave = {
//                 PARENT_SLUG: subchapterParentSlug,
//                 SLUG: newChapterSlug,
//                 INDEX: parseInt(newChapter.index) > maxIndex ? maxIndex : parseInt(newChapter.index),
//                 PHOTO: newChapter.img,
//                 NAME: newChapter.title,
//             }
//         } 
//         let chaptersToUpdate = [];
//         let indexIncrement = 0;
//         let newChapters = [];
//         chapters.map((chapter) => {
//             if (chapterToSave && chapterToSave.INDEX && chapter.index === chapterToSave.INDEX) {
//                 indexIncrement++;
//                 chaptersToUpdate.push(chapterToSave);
//                 newChapters.push({
//                     id: chapterToSave.ARCIMEDES_ROW_ID,
//                     slug: chapterToSave.SLUG,
//                     title: chapterToSave.NAME,
//                     index: parseInt(chapterToSave.INDEX),
//                     img: chapterToSave.PHOTO,
//                 });
//             }
//             //chapter is modified
//             if (indexIncrement !== 0 || !this.state.originalChapters.some(ch => isEqual(ch,chapter))){
//                 chaptersToUpdate.push({
//                     ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
//                     PARENT_SLUG: subchapterParentSlug,
//                     SLUG: this.getNewSlug(chapter.slug),
//                     INDEX: parseInt(chapter.index) + indexIncrement,
//                     PHOTO: chapter.img ? chapter.img.split('v0/')[1] : chapter.img,
//                     NAME: chapter.title
//                 })
//                 newChapters.push({...chapter, slug: this.getNewSlug(chapter.slug), index:parseInt(chapter.index) + indexIncrement});
//             }
//             else
//                 newChapters.push(chapter);
//         });

//         if(this.state.originalChapters.length != chapters.length){
//             const deletedElements = this.state.originalChapters.filter(ch1 => !chapters.some(ch2 => ch2.id === ch1.id));

//             deletedElements.forEach((chapter) => {
//                 chaptersToUpdate.push({
//                     ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
//                     PARENT_SLUG: subchapterParentSlug,
//                     SLUG: this.getNewSlug(chapter.slug),
//                     INDEX: parseInt(chapter.index) + indexIncrement,
//                     PHOTO: chapter.img ? chapter.img.split('v0/')[1] : chapter.img,
//                     NAME: chapter.title,
//                     DELETED: 1
//                 })
//             });
//         }
                
//         if (indexIncrement === 0 && Object.keys(chapterToSave).length > 0) {
//             chaptersToUpdate.push(chapterToSave);
//             newChapters.push({
//                 id: chapterToSave.ARCIMEDES_ROW_ID,
//                 slug: chapterToSave.SLUG,
//                 title: chapterToSave.NAME,
//                 index: chapterToSave.INDEX,
//                 img: chapterToSave.PHOTO,
//             });
//         }

//         if ((newChapter && newChapter.visible) || !isEqual(this.state.originalChapters,chapters))
//             manageData({
//                 tableCode: TRAINING,
//                 data: chaptersToUpdate.length ? chaptersToUpdate : chapters
//             }).then(res => {
//                 if (res && res.success) {
//                     let savedChapter = {};
//                     if (chapterToSave) {
//                         res.data.map((chapter) => {
//                             if (parseInt(chapter.INDEX) === chapterToSave.INDEX) {
//                                 savedChapter = chapter;
//                             }
//                         });
//                         newChapters = sortArray([...newChapters.filter(ch=> ch.index !== chapterToSave.INDEX), {
//                             id: savedChapter.ARCIMEDES_ROW_ID,
//                             slug: savedChapter.SLUG,
//                             title: savedChapter.NAME,
//                             index: savedChapter.INDEX,
//                             img: savedChapter.PHOTO,
//                         }],'index');
//                     }
//                     let newChapter = {visible: false};
//                     const previousIndexes = savedChapter ?
//                         [
//                             ...this.state.previousIndexes,
//                             {
//                                 id: savedChapter.ARCIMEDES_ROW_ID,
//                                 index: savedChapter.INDEX
//                             }
//                         ] : this.state.previousIndexes;
//                     this.setState({
//                         chapters: newChapters,
//                         originalChapters: newChapters,
//                         newChapter,
//                         previousIndexes,
//                         error: null
//                         },
//                         this.toggleEdit
//                     );
//                     return;
//                 }
//                 this.setState({
//                     error: res && res.message ? res.message : "Unspecified error",
//                 });
//             });

//         else if (!newChapter || isEqual(this.state.originalChapters, chapters))
//             this.toggleEdit();
//     }
    
//     handleInputBlur(key, value, isNewChapter=false){
//         let chapters = cloneDeep(this.state.chapters);
//         if (!isNewChapter) {
//             const id = key.split('_')[0];
//             const newKey = key.split('_')[1];
//             const newValue = Number(value);
//             let previousIndexes = cloneDeep(this.state.previousIndexes)
//             let currentChapterInfo = previousIndexes.find((ch) => ch.id === id);
//             const previousIndex = currentChapterInfo.index;

//             if (newKey === 'index' && previousIndex && newValue !== previousIndex) {
//                 chapters.filter((ch) => ch.id !== id).map((chapter) => {
//                     if (chapter.index <= newValue && chapter.index > previousIndex) {
//                         chapter.index--;
//                         previousIndexes.find((o)=> o.id === chapter.id).index = chapter.index;
//                     }
//                     else if (chapter.index >= newValue && chapter.index < previousIndex) {
//                         chapter.index++;
//                         previousIndexes.find((o) => o.id === chapter.id).index = chapter.index;
//                     }
//                 })
//                 chapters = sortArray(chapters, 'index');
//                 currentChapterInfo.index = newValue;
//                 previousIndexes = [...previousIndexes.filter(ch => ch.id !== id), currentChapterInfo]
//                 this.setState({chapters, previousIndexes});
//             }
//         }
//     }

//     handleInputChange(key, value, isNewChapter = false){
//         if (isNewChapter) {
//             let newChapter = cloneDeep(this.state.newChapter);
//             newChapter[key] = value;
//             this.setState({newChapter})
//         } else {
//             let chapters = cloneDeep(this.state.chapters);
//             const id = key.split('_')[0];
//             const newKey = key.split('_')[1];
//             let currentChapter = chapters.find((el) => el.id === id);
//             if (newKey === 'index') {
//                 currentChapter[newKey] = Number(value);
//             } else
//                 currentChapter[newKey] = value;
//             this.setState({chapters});
//         }
//     }
    
//     fetch(params) {
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');
//         const slug = slugs[slugs.length - 1] || '';
//         const parentChapterSlug = slugs[slugs.length - 2] || '';
//         slugs.pop();
//         const parentSlug = slugs.join('/') || 'training';
//         let parentChapterParentSlug = ''
//         if (slugs.length) {
//             slugs.pop();
//             parentChapterParentSlug = slugs.join('/') || 'training';
//         }
//         const hasVideo = parentSlug === 'brokerage-continuum';

//         const requests = [
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                         'VIDEO_LINK',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: slug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: subchapterParentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//         ];

//         if (parentChapterParentSlug)
//             requests.push(
//                 getData({
//                     tableCode: TRAINING,
//                     options: {
//                         column: [
//                             'NAME',
//                         ],
//                         filter: [{
//                             text: '',
//                             code: 'DELETED',
//                             type: 'null',
//                         }, {
//                             text: parentChapterParentSlug,
//                             code: 'PARENT_SLUG',
//                             type: 'exact',
//                         }, {
//                             text: parentChapterSlug,
//                             code: 'SLUG',
//                             type: 'exact',
//                         }],
//                         filterType: 'and',
//                     },
//                 })
//             )

//         Promise.all(requests).then(res => {
//             if (res && res[0] && res[0].success && res[1] && res[1].success && (res[2] && res[2].success || !res[2])) {
//                 const chapters = sortArray(
//                     res[1].data.map((chapter) => {
//                         return {
//                             id: chapter.ARCIMEDES_ROW_ID,
//                             slug: chapter.SLUG,
//                             title: chapter.NAME,
//                             index: parseInt(chapter.INDEX),
//                             img: chapter.PHOTO ? `${arc.path.media}${chapter.PHOTO}` : null,
//                         }
//                     }), 'index');

//                 let previousIndexes = [];
//                 chapters.map( (ch) =>{ 
//                     const id = ch.id; 
//                     const index = ch.index;
//                     previousIndexes.push({id, index});
//                 })
//                 this.setState({
//                     originalChapters: cloneDeep(chapters),
//                     chapters,
//                     previousIndexes,
//                     title: res[0].data[0].NAME || '',
//                     hasVideo,
//                     videoLink: res[0].data[0].VIDEO_LINK || '',
//                     backButton: res[2] ? res[2].data[0].NAME : 'TRAINING',
//                 });
//             }
//         });
//     }

//     cancelChanges() {
//         const original = cloneDeep(this.state.originalChapters);
//         if(newChapter && newChapter.visible)
//             this.removePhoto();

//         const newChapter = {visible : false};
//         this.setState({chapters:original, newChapter}, this.toggleEdit);
//     }

//     uploadPhoto(id) {
//         const fileName = this.state.uploadedImage.name;
//         const base64File = this.state.uploadedImage.base64;
//         return uploadFile({fileName, base64File, folder:FOLDER}).then(res => {
//             res = res.data.responses[0];
//             if (!res || !res.success) {
//                 if (res.errorCode === existingFileError) {
//                         this.setState({
//                             uploadedImage: null,
//                             error: existingFileErrorMessage
//                         });
//                 } else {
//                     this.setState({
//                         error: res && res.message ? res.message : "Unspecified error",
//                     });
//                 }
//             } else {
//                 if(!id){
//                     const newChapter = {...this.state.newChapter}
//                     const image = res.data.url.split('/v0/')[1];
//                     newChapter.img = image;
//                     this.setState({newChapter, error:null});
//                 } else {
//                     let chapters = this.state.chapters;
//                     let currentChapter = chapters.find((el) => el.id === id);
//                     currentChapter.img = arc.path.media + res.data.url.split('/v0/')[1];
//                     this.setState({chapters, error:null});
//                 }
//             }
//         })
//     }
//     deleteCard(id){
//         let chapters = cloneDeep(this.state.chapters);
//         chapters = chapters.filter((e)=> e.id!=id);
//         this.setState({chapters});
//     }

//     removePhoto(id) {
//         let chapter = {};        
//         let chapters = cloneDeep(this.state.chapters)

//         if(id)
//             chapter = chapters.find((ch)=>ch.id === id);
//         const fileName = id ? (chapter.img ? chapter.img.split('_')[1] : null) : this.state.newChapter.img.split('_')[1];
//         let newChapter = cloneDeep(this.state.newChapter);
//         if(fileName)
//             removeFile({fileName, folder:FOLDER+'/'}).then(res => {
//                 if (!res || !res.success) {
//                     if (res.errorCode === missingFileError) {
//                         if(!id) {
//                             newChapter.img = null;
//                             this.setState({
//                                 uploadedFile: null,
//                                 newChapter
//                             });
//                         }
//                         else {
//                             chapter.img = null;
//                             this.setState({
//                                 chapters,
//                                 error:'File not found.'
//                             });
//                         }
//                     } else {
//                         this.setState({
//                             error: res && res.message ? res.message : "Unspecified error",
//                         });
//                     }
//                 } else {
//                     if(!id){
//                         newChapter.img = null;
//                         this.setState({
//                             uploadedFile: null,
//                             newChapter, 
//                             error:null
//                         });
//                     } else {
//                         let chapters = this.state.chapters;
//                         let chapter = chapters.find(el => el.id === id)
//                         chapter.img = null;

//                         manageData({
//                             tableCode: TRAINING,
//                             data: [{
//                                 ARCIMEDES_ROW_ID: chapter.id,
//                                 PHOTO: null,
//                                 NAME: chapter.title,
//                                 INDEX: chapter.index,
//                                 SLUG: chapter.slug
//                             }]
//                         }).then(res => {
//                             if (res && res.success) {
//                                 this.setState({chapters, error:null});
//                                 return;
//                             }
//                             this.setState({
//                                 error: res && res.message ? res.message : "Unspecified error",
//                             });
//                         });
//                     }
//                 }
//             });
//     }

//     validateSelectedFile(event, id) {
//         let selectedFile = event.currentTarget.files[0];
//         const fileSize = selectedFile.size / 1000000; //mb

//         if (fileSize > 20){
//             this.setState({error:'Maximum file size exceeded'});
//             return;
//         }
//         getBase64(selectedFile).then(result => {
//             selectedFile["base64"] = result;
//             this.setState({
//                 uploadedImage: selectedFile
//             }, () => id ? this.uploadPhoto(id) : this.uploadPhoto());
//         });
//     }

//     render() {
//         const {isSuper} = this.props;
//         const {chapters, title, hasVideo, videoLink, backButton, isEdit, newChapter, error} = this.state;
        
//         return (
//             <div className='ChapterPage'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button' onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             {backButton}
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>{title}</div>
//                             {
//                                 isSuper && isEdit &&
//                                 <React.Fragment>
//                                     <div className='button-new negative' onClick={this.cancelChanges}>Cancel</div>
//                                     <div className='button-new positive' onClick={this.saveChanges}>Save</div>
//                                 </React.Fragment>
//                             }
//                             {
//                                 isSuper && !isEdit &&
//                                 <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
//                             }
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='cards-container'>
//                     {
//                         chapters.filter((e)=> e.id).map(chapter => (
//                             <SubChapterCard
//                                 id={chapter.id}
//                                 key={chapter.slug}
//                                 img={chapter.img}
//                                 title={chapter.title}
//                                 index={chapter.index}
//                                 link={`${this.props.location.pathname}/${chapter.slug}`}
//                                 handleParentChange={this.handleInputChange}
//                                 handleParentBlur={this.handleInputBlur}
//                                 isEdit={isEdit}
//                                 error={error}
//                                 deleteCard={(id)=>this.deleteCard(id)}
//                                 validateSelectedFile={this.validateSelectedFile}
//                                 removePhoto={(id)=>this.removePhoto(id)}
//                             />
//                         ))
//                     }
//                     {
//                         hasVideo &&
//                         <SubChapterCard
//                             key='video'
//                             img={arc.path.media + videoImage}
//                             title='Video'
//                             link={videoLink}
//                             newWindow
//                         />
//                     }
//                     { isEdit &&
//                         <SubChapterCard
//                             isNewChapter={true}
//                             newChapter={newChapter}
//                             handleParentChange={this.handleInputChange}
//                             isEdit={isEdit}
//                             error={error}
//                             validateSelectedFile={this.validateSelectedFile}
//                             removePhoto={(id)=>this.removePhoto(id)}
//                             deleteCard={(id)=>this.deleteCard(id)}
//                             addNewChapter={() => this.setState({newChapter:{visible:true}})}
//                         />
//                     }    
//                 </div>
//             </div>
//         )
//     }
// }
//#region Old Code
// import React from "react";
// import SubChapterCard from "../SubChapterCard";
// import {getData, manageData} from "../../requests/CRUD";
// import {getBase64, sortArray} from "../../utils";
// import Icon from "../Icon";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {TRAINING} from "../../consts/tables";
// import {existingFileError, existingFileErrorMessage, missingFileError, videoImage} from "../../consts/consts";
// import { removeFile, uploadFile } from "../../requests/fileRequests";
// import isEqual from "lodash.isequal";

// let cloneDeep = require('lodash.clonedeep');

// const FOLDER = 'training'
// export default class ChapterPage extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             originalChapters: [],
//             chapters: [],
//             title: '',
//             hasVideo: false,
//             videoLink: '',
//             backButton: '',
//             isEdit: false,
//             newChapter: {visible:false},
//             uploadedImage: null,
//             error: null,
//             lastModified: null,
//             previousIndexes: []
//         };

//         this.toggleEdit = this.toggleEdit.bind(this);
//         this.handleInputChange = this.handleInputChange.bind(this);
//         this.handleInputBlur = this.handleInputBlur.bind(this);
//         this.cancelChanges = this.cancelChanges.bind(this);
//         this.saveChanges = this.saveChanges.bind(this);
//         this.validateSelectedFile = this.validateSelectedFile.bind(this);
//         this.uploadPhoto = this.uploadPhoto.bind(this);
//         this.removePhoto = this.removePhoto.bind(this);
//         this.deleteCard =  this.deleteCard.bind(this);
//     }

//     componentDidMount() {
//         this.fetch(this.props.params);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
//             this.fetch(nextProps.params);
//     }

//     toggleEdit() {
//         this.setState(prevState => {
//             return {
//                 isEdit: !prevState.isEdit
//             }
//         });
//     }

//     getNewSlug(title){
//         return title.toString().toLowerCase()
//                 .replace(/[&]/g,'and')              //replace '&' with 'and'
//                 .replace(/<br\/>|\s(-|\/)\s/g,'')  // remove ' - ', ' / ', '</br>'
//                 .replace(/[^\w\s\/\-]/g, '')        //replace punctuation characters except '/' and '-'
//                 .replace(/[\/ ]/g, "-");            //replace ' ' and '/' with '-'
//     }

//     saveChanges() { 
//         const params = this.props.params;
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');

//         const chapters = cloneDeep(this.state.chapters);

//         const newChapter = cloneDeep(this.state.newChapter);
//         let chapterToSave = {};
//         if (newChapter && newChapter.visible) {
//             const maxIndex = chapters.length ? Math.max(...chapters.map(ch => ch.index)) + 1 : 1;
//             let newChapterSlug = this.getNewSlug(newChapter.title);
//             chapterToSave = {
//                 PARENT_SLUG: subchapterParentSlug,
//                 SLUG: newChapterSlug,
//                 INDEX: parseInt(newChapter.index) > maxIndex ? maxIndex : parseInt(newChapter.index),
//                 PHOTO: newChapter.img,
//                 NAME: newChapter.title,
//             }
//         } 
//         let chaptersToUpdate = [];
//         let indexIncrement = 0;
//         let newChapters = [];
//         chapters.map((chapter) => {
//             if (chapterToSave && chapterToSave.INDEX && chapter.index === chapterToSave.INDEX) {
//                 indexIncrement++;
//                 chaptersToUpdate.push(chapterToSave);
//                 newChapters.push({
//                     id: chapterToSave.ARCIMEDES_ROW_ID,
//                     slug: chapterToSave.SLUG,
//                     title: chapterToSave.NAME,
//                     index: parseInt(chapterToSave.INDEX),
//                     img: chapterToSave.PHOTO,
//                 });
//             }
//             //chapter is modified
//             if (indexIncrement !== 0 || !this.state.originalChapters.some(ch => isEqual(ch,chapter))){
//                 chaptersToUpdate.push({
//                     ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
//                     PARENT_SLUG: subchapterParentSlug,
//                     SLUG: this.getNewSlug(chapter.slug),
//                     INDEX: parseInt(chapter.index) + indexIncrement,
//                     PHOTO: chapter.img ? chapter.img.split('v0/')[1] : chapter.img,
//                     NAME: chapter.title
//                 })
//                 newChapters.push({...chapter, slug: this.getNewSlug(chapter.slug), index:parseInt(chapter.index) + indexIncrement});
//             }
//             else
//                 newChapters.push(chapter);
//         });

//         if(this.state.originalChapters.length != chapters.length){
//             const deletedElements = this.state.originalChapters.filter(ch1 => !chapters.some(ch2 => ch2.id === ch1.id));

//             deletedElements.forEach((chapter) => {
//                 chaptersToUpdate.push({
//                     ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
//                     PARENT_SLUG: subchapterParentSlug,
//                     SLUG: this.getNewSlug(chapter.slug),
//                     INDEX: parseInt(chapter.index) + indexIncrement,
//                     PHOTO: chapter.img ? chapter.img.split('v0/')[1] : chapter.img,
//                     NAME: chapter.title,
//                     DELETED: 1
//                 })
//             });
//         }

//         if (indexIncrement === 0 && Object.keys(chapterToSave).length > 0) {
//             chaptersToUpdate.push(chapterToSave);
//             newChapters.push({
//                 id: chapterToSave.ARCIMEDES_ROW_ID,
//                 slug: chapterToSave.SLUG,
//                 title: chapterToSave.NAME,
//                 index: chapterToSave.INDEX,
//                 img: chapterToSave.PHOTO,
//             });
//         }

//         if ((newChapter && newChapter.visible) || !isEqual(this.state.originalChapters,chapters))
//             manageData({
//                 tableCode: TRAINING,
//                 data: chaptersToUpdate.length ? chaptersToUpdate : chapters
//             }).then(res => {
//                 if (res && res.success) {
//                     let savedChapter = {};
//                     if (chapterToSave) {
//                         res.data.map((chapter) => {
//                             if (parseInt(chapter.INDEX) === chapterToSave.INDEX) {
//                                 savedChapter = chapter;
//                             }
//                         });
//                         newChapters = sortArray([...newChapters.filter(ch=> ch.index !== chapterToSave.INDEX), {
//                             id: savedChapter.ARCIMEDES_ROW_ID,
//                             slug: savedChapter.SLUG,
//                             title: savedChapter.NAME,
//                             index: savedChapter.INDEX,
//                             img: savedChapter.PHOTO,
//                         }],'index');
//                     }
//                     let newChapter = {visible: false};
//                     const previousIndexes = savedChapter ?
//                         [
//                             ...this.state.previousIndexes,
//                             {
//                                 id: savedChapter.ARCIMEDES_ROW_ID,
//                                 index: savedChapter.INDEX
//                             }
//                         ] : this.state.previousIndexes;
//                     this.setState({
//                         chapters: newChapters,
//                         originalChapters: newChapters,
//                         newChapter,
//                         previousIndexes,
//                         error: null
//                         },
//                         this.toggleEdit
//                     );
//                     return;
//                 }
//                 this.setState({
//                     error: res && res.message ? res.message : "Unspecified error",
//                 });
//             });

//         else if (!newChapter || isEqual(this.state.originalChapters, chapters))
//             this.toggleEdit();
//     }

//     handleInputBlur(key, value, isNewChapter=false){
//         let chapters = cloneDeep(this.state.chapters);
//         if (!isNewChapter) {
//             const id = key.split('_')[0];
//             const newKey = key.split('_')[1];
//             const newValue = Number(value);
//             let previousIndexes = cloneDeep(this.state.previousIndexes)
//             let currentChapterInfo = previousIndexes.find((ch) => ch.id === id);
//             const previousIndex = currentChapterInfo.index;

//             if (newKey === 'index' && previousIndex && newValue !== previousIndex) {
//                 chapters.filter((ch) => ch.id !== id).map((chapter) => {
//                     if (chapter.index <= newValue && chapter.index > previousIndex) {
//                         chapter.index--;
//                         previousIndexes.find((o)=> o.id === chapter.id).index = chapter.index;
//                     }
//                     else if (chapter.index >= newValue && chapter.index < previousIndex) {
//                         chapter.index++;
//                         previousIndexes.find((o) => o.id === chapter.id).index = chapter.index;
//                     }
//                 })
//                 chapters = sortArray(chapters, 'index');
//                 currentChapterInfo.index = newValue;
//                 previousIndexes = [...previousIndexes.filter(ch => ch.id !== id), currentChapterInfo]
//                 this.setState({chapters, previousIndexes});
//             }
//         }
//     }

//     handleInputChange(key, value, isNewChapter = false){
//         if (isNewChapter) {
//             let newChapter = cloneDeep(this.state.newChapter);
//             newChapter[key] = value;
//             this.setState({newChapter})
//         } else {
//             let chapters = cloneDeep(this.state.chapters);
//             const id = key.split('_')[0];
//             const newKey = key.split('_')[1];
//             let currentChapter = chapters.find((el) => el.id === id);
//             if (newKey === 'index') {
//                 currentChapter[newKey] = Number(value);
//             } else
//                 currentChapter[newKey] = value;
//             this.setState({chapters});
//         }
//     }

//     fetch(params) {
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');
//         const slug = slugs[slugs.length - 1] || '';
//         const parentChapterSlug = slugs[slugs.length - 2] || '';
//         slugs.pop();
//         const parentSlug = slugs.join('/') || 'training';
//         let parentChapterParentSlug = ''
//         if (slugs.length) {
//             slugs.pop();
//             parentChapterParentSlug = slugs.join('/') || 'training';
//         }
//         const hasVideo = parentSlug === 'brokerage-continuum';

//         const requests = [
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                         'VIDEO_LINK',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: slug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: subchapterParentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//         ];

//         if (parentChapterParentSlug)
//             requests.push(
//                 getData({
//                     tableCode: TRAINING,
//                     options: {
//                         column: [
//                             'NAME',
//                         ],
//                         filter: [{
//                             text: '',
//                             code: 'DELETED',
//                             type: 'null',
//                         }, {
//                             text: parentChapterParentSlug,
//                             code: 'PARENT_SLUG',
//                             type: 'exact',
//                         }, {
//                             text: parentChapterSlug,
//                             code: 'SLUG',
//                             type: 'exact',
//                         }],
//                         filterType: 'and',
//                     },
//                 })
//             )

//         Promise.all(requests).then(res => {
//             if (res && res[0] && res[0].success && res[1] && res[1].success && (res[2] && res[2].success || !res[2])) {
//                 const chapters = sortArray(
//                     res[1].data.map((chapter) => {
//                         return {
//                             id: chapter.ARCIMEDES_ROW_ID,
//                             slug: chapter.SLUG,
//                             title: chapter.NAME,
//                             index: parseInt(chapter.INDEX),
//                             img: chapter.PHOTO ? `${arc.path.media}${chapter.PHOTO}` : null,
//                         }
//                     }), 'index');

//                 let previousIndexes = [];
//                 chapters.map( (ch) =>{ 
//                     const id = ch.id; 
//                     const index = ch.index;
//                     previousIndexes.push({id, index});
//                 })
//                 this.setState({
//                     originalChapters: cloneDeep(chapters),
//                     chapters,
//                     previousIndexes,
//                     title: res[0].data[0].NAME || '',
//                     hasVideo,
//                     videoLink: res[0].data[0].VIDEO_LINK || '',
//                     backButton: res[2] ? res[2].data[0].NAME : 'TRAINING',
//                 });
//             }
//         });
//     }

//     cancelChanges() {
//         const original = cloneDeep(this.state.originalChapters);
//         if(newChapter && newChapter.visible)
//             this.removePhoto();

//         const newChapter = {visible : false};
//         this.setState({chapters:original, newChapter}, this.toggleEdit);
//     }

//     uploadPhoto(id) {
//         const fileName = this.state.uploadedImage.name;
//         const base64File = this.state.uploadedImage.base64;
//         return uploadFile({fileName, base64File, folder:FOLDER}).then(res => {
//             res = res.data.responses[0];
//             if (!res || !res.success) {
//                 if (res.errorCode === existingFileError) {
//                         this.setState({
//                             uploadedImage: null,
//                             error: existingFileErrorMessage
//                         });
//                 } else {
//                     this.setState({
//                         error: res && res.message ? res.message : "Unspecified error",
//                     });
//                 }
//             } else {
//                 if(!id){
//                     const newChapter = {...this.state.newChapter}
//                     const image = res.data.url.split('/v0/')[1];
//                     newChapter.img = image;
//                     this.setState({newChapter, error:null});
//                 } else {
//                     let chapters = this.state.chapters;
//                     let currentChapter = chapters.find((el) => el.id === id);
//                     currentChapter.img = arc.path.media + res.data.url.split('/v0/')[1];
//                     this.setState({chapters, error:null});
//                 }
//             }
//         })
//     }
//     deleteCard(id){
//         let chapters = cloneDeep(this.state.chapters);
//         chapters = chapters.filter((e)=> e.id!=id);
//         this.setState({chapters});
//     }

//     removePhoto(id) {
//         let chapter = {};        
//         let chapters = cloneDeep(this.state.chapters)

//         if(id)
//             chapter = chapters.find((ch)=>ch.id === id);
//         const fileName = id ? (chapter.img ? chapter.img.split('_')[1] : null) : this.state.newChapter.img.split('_')[1];
//         let newChapter = cloneDeep(this.state.newChapter);
//         if(fileName)
//             removeFile({fileName, folder:FOLDER+'/'}).then(res => {
//                 if (!res || !res.success) {
//                     if (res.errorCode === missingFileError) {
//                         if(!id) {
//                             newChapter.img = null;
//                             this.setState({
//                                 uploadedFile: null,
//                                 newChapter
//                             });
//                         }
//                         else {
//                             chapter.img = null;
//                             this.setState({
//                                 chapters,
//                                 error:'File not found.'
//                             });
//                         }
//                     } else {
//                         this.setState({
//                             error: res && res.message ? res.message : "Unspecified error",
//                         });
//                     }
//                 } else {
//                     if(!id){
//                         newChapter.img = null;
//                         this.setState({
//                             uploadedFile: null,
//                             newChapter, 
//                             error:null
//                         });
//                     } else {
//                         let chapters = this.state.chapters;
//                         let chapter = chapters.find(el => el.id === id)
//                         chapter.img = null;

//                         manageData({
//                             tableCode: TRAINING,
//                             data: [{
//                                 ARCIMEDES_ROW_ID: chapter.id,
//                                 PHOTO: null,
//                                 NAME: chapter.title,
//                                 INDEX: chapter.index,
//                                 SLUG: chapter.slug
//                             }]
//                         }).then(res => {
//                             if (res && res.success) {
//                                 this.setState({chapters, error:null});
//                                 return;
//                             }
//                             this.setState({
//                                 error: res && res.message ? res.message : "Unspecified error",
//                             });
//                         });
//                     }
//                 }
//             });
//     }

//     validateSelectedFile(event, id) {
//         let selectedFile = event.currentTarget.files[0];
//         const fileSize = selectedFile.size / 1000000; //mb

//         if (fileSize > 20){
//             this.setState({error:'Maximum file size exceeded'});
//             return;
//         }
//         getBase64(selectedFile).then(result => {
//             selectedFile["base64"] = result;
//             this.setState({
//                 uploadedImage: selectedFile
//             }, () => id ? this.uploadPhoto(id) : this.uploadPhoto());
//         });
//     }

//     render() {
//         const {isSuper} = this.props;
//         const {chapters, title, hasVideo, videoLink, backButton, isEdit, newChapter, error} = this.state;

//         return (
//             <div className='ChapterPage'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button' onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             {backButton}
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>{title}</div>
//                             {
//                                 isSuper && isEdit &&
//                                 <React.Fragment>
//                                     <div className='button-new negative' onClick={this.cancelChanges}>Cancel</div>
//                                     <div className='button-new positive' onClick={this.saveChanges}>Save</div>
//                                 </React.Fragment>
//                             }
//                             {
//                                 isSuper && !isEdit &&
//                                 <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
//                             }
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='cards-container'>
//                     {
//                         chapters.filter((e)=> e.id).map(chapter => (
//                             <SubChapterCard
//                                 id={chapter.id}
//                                 key={chapter.slug}
//                                 img={chapter.img}
//                                 title={chapter.title}
//                                 index={chapter.index}
//                                 link={`${this.props.location.pathname}/${chapter.slug}`}
//                                 handleParentChange={this.handleInputChange}
//                                 handleParentBlur={this.handleInputBlur}
//                                 isEdit={isEdit}
//                                 error={error}
//                                 deleteCard={(id)=>this.deleteCard(id)}
//                                 validateSelectedFile={this.validateSelectedFile}
//                                 removePhoto={(id)=>this.removePhoto(id)}
//                             />
//                         ))
//                     }
//                     {
//                         hasVideo &&
//                         <SubChapterCard
//                             key='video'
//                             img={arc.path.media + videoImage}
//                             title='Video'
//                             link={videoLink}
//                             newWindow
//                         />
//                     }
//                     { isEdit &&
//                         <SubChapterCard
//                             isNewChapter={true}
//                             newChapter={newChapter}
//                             handleParentChange={this.handleInputChange}
//                             isEdit={isEdit}
//                             error={error}
//                             validateSelectedFile={this.validateSelectedFile}
//                             removePhoto={(id)=>this.removePhoto(id)}
//                             deleteCard={(id)=>this.deleteCard(id)}
//                             addNewChapter={() => this.setState({newChapter:{visible:true}})}
//                         />
//                     }    
//                 </div>
//             </div>
//         )
//     }
// }

//#endregion

import React from "react";
import SubChapterCard from "../SubChapterCard";
import { getData, manageData } from "../../requests/CRUD";
import { getBase64, sortArray, isAuthorizedForTrainingDelete } from "../../utils";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
// import {TRAINING} from "../../consts/tables";
import { existingFileError, existingFileErrorMessage, missingFileError, videoImage } from "../../consts/consts";
import { removeFile, uploadFile } from "../../requests/fileRequests";
import isEqual from "lodash.isequal";
import { ApolloConsumer } from "@apollo/client";
import { TRAINING, TRAINING_CONTENT } from "../Graphql/Mutations/TrainingMutation";
import { GET_TRAINING, GET_TRAINING_CONTENT } from "../Graphql/Queries/TrainingQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import Input from "../Input-new/Input";

let cloneDeep = require('lodash.clonedeep');

const FOLDER = 'training'
export default class ChapterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            originalChapters: [],
            chapters: [],
            title: '',
            hasVideo: false,
            videoLink: '',
            backButton: '',
            isEdit: false,
            newChapter: { visible: false },
            uploadedImage: null,
            error: null,
            lastModified: null,
            previousIndexes: [],
            contentResp: null,
            nodePhoto: null,
            nodeName: '',
            nodeImagePath: null,
            nodeLoadedFor: null,
            nodeId: null,
            originalVideoLink: ''
        };

        this.contentRef = React.createRef();
        this.migrating = false;

        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.validateSelectedFile = this.validateSelectedFile.bind(this);
        this.uploadPhoto = this.uploadPhoto.bind(this);
        this.removePhoto = this.removePhoto.bind(this);
        this.deleteCard = this.deleteCard.bind(this);
        this.maybeMigrateContent = this.maybeMigrateContent.bind(this);
    }

    componentDidMount() {
        this.fetch(this.props.params);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
            this.fetch(nextProps.params);
    }

    toggleEdit() {
        this.setState(prevState => {
            return {
                isEdit: !prevState.isEdit
            }
        });
    }

    getNewSlug(title) {
        return title && title.toString().toLowerCase()
            .replace(/[&]/g, 'and')              //replace '&' with 'and'
            .replace(/<br\/>|\s(-|\/)\s/g, '')  // remove ' - ', ' / ', '</br>'
            .replace(/[^\w\s\/\-]/g, '')        //replace punctuation characters except '/' and '-'
            .replace(/[\/ ]/g, "-");            //replace ' ' and '/' with '-'
    }

    saveChanges() {
        const params = this.props.params;
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');

        const chapters = cloneDeep(this.state.chapters);

        const newChapter = cloneDeep(this.state.newChapter);
        let chapterToSave = {};
        if (newChapter && newChapter.visible) {
            const maxIndex = chapters.length ? Math.max(...chapters.map(ch => ch.index)) + 1 : 1;
            let newChapterSlug = this.getNewSlug(newChapter.title);
            chapterToSave = {
                PARENT_SLUG: subchapterParentSlug,
                SLUG: newChapterSlug,
                INDEX: parseInt(newChapter.index) > maxIndex ? maxIndex : parseInt(newChapter.index),
                PHOTO: newChapter.imageAddress,
                NAME: newChapter.title,
            }
        }
        let chaptersToUpdate = [];
        let indexIncrement = 0;
        let newChapters = [];
        chapters.map((chapter) => {
            if (chapterToSave && chapterToSave.INDEX && chapter.index === chapterToSave.INDEX) {
                indexIncrement++;
                chaptersToUpdate.push(chapterToSave);
                newChapters.push({
                    id: chapterToSave.ARCIMEDES_ROW_ID,
                    slug: chapterToSave.SLUG,
                    title: chapterToSave.NAME,
                    index: parseInt(chapterToSave.INDEX),
                    img: chapterToSave.PHOTO,
                });
            }
            //chapter is modified
            if (indexIncrement !== 0 || !this.state.originalChapters.some(ch => isEqual(ch, chapter))) {
                chaptersToUpdate.push({
                    ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
                    PARENT_SLUG: subchapterParentSlug,
                    SLUG: this.getNewSlug(chapter.slug),
                    INDEX: parseInt(chapter.index) + indexIncrement,
                    PHOTO: chapter.imageAddress ? chapter.imageAddress : chapter.imagePath ? chapter.imagePath: null,
                    NAME: chapter.title
                })
                newChapters.push({ ...chapter, slug: this.getNewSlug(chapter.slug), index: parseInt(chapter.index) + indexIncrement });
            }
            else
                newChapters.push(chapter);
        });

        if (this.state.originalChapters.length != chapters.length) {
            const deletedElements = this.state.originalChapters.filter(ch1 => !chapters.some(ch2 => ch2.id === ch1.id));

            deletedElements.forEach((chapter) => {
                chaptersToUpdate.push({
                    ARCIMEDES_ROW_ID: chapter.id ? chapter.id : null,
                    PARENT_SLUG: subchapterParentSlug,
                    SLUG: this.getNewSlug(chapter.slug),
                    INDEX: parseInt(chapter.index) + indexIncrement,
                     PHOTO: chapter.imageAddress ? chapter.imageAddress : chapter.imagePath ? chapter.imagePath: null,
                    NAME: chapter.title,
                    DELETED: 1
                })
            });
        }

        if (indexIncrement === 0 && Object.keys(chapterToSave).length > 0) {
            chaptersToUpdate.push(chapterToSave);
            newChapters.push({
                id: chapterToSave.ARCIMEDES_ROW_ID,
                slug: chapterToSave.SLUG,
                title: chapterToSave.NAME,
                index: chapterToSave.INDEX,
                img: chapterToSave.PHOTO,
            });
        }

        // Update this section's video link when the admin changed it.
        const videoLinkChanged = this.state.hasVideo && this.state.nodeId
            && (this.state.videoLink || '') !== (this.state.originalVideoLink || '');
        if (videoLinkChanged)
            chaptersToUpdate.push({
                ARCIMEDES_ROW_ID: this.state.nodeId,
                VIDEO_LINK: this.state.videoLink,
            });

        if ((newChapter && newChapter.visible) || !isEqual(this.state.originalChapters, chapters) || videoLinkChanged)
            {
            // manageData({
            //     tableCode: TRAINING,
            //     data: chaptersToUpdate.length ? chaptersToUpdate : chapters
            // })
            const token = localStorage.getItem('authToken');
           let payload = chaptersToUpdate.length ? chaptersToUpdate : chapters;
           const expectedPayload = payload.map(obj => {
            return Object.keys(obj).reduce((acc, key) => {
              acc[key.toLowerCase()] = obj[key];
              return acc;
            }, {});
          });
            // this.client.mutate({ 
            //     //mutation: TRAINING, variables: { data: chaptersToUpdate.length ? chaptersToUpdate : chapters } })
            //     mutation: TRAINING,
            //     variables: { input: expectedPayload },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     },
            //   })
              mutateData(TRAINING, { input: expectedPayload })
                .then(res => {
                    if (res && res.data && res.data.createOrUpdateTraining) {
                        let savedChapter = {};
                        if (chapterToSave) {
                            (res.data.createOrUpdateTraining.data || []).map((chapter) => {
                                // parent_slug check: the response can also contain this section's own
                                // row (video link update), which must not be matched as a new tile.
                                if (parseInt(chapter.index) === chapterToSave.INDEX && chapter.parent_slug === subchapterParentSlug) {
                                    savedChapter = chapter;
                                }
                            });
                            newChapters = sortArray([...newChapters.filter(ch => ch.index !== chapterToSave.INDEX), {
                                id: savedChapter.arcimedes_row_id,
                                slug: savedChapter.slug,
                                title: savedChapter.name,
                                index: savedChapter.index,
                                img: savedChapter.photo,
                            }], 'index');
                        }
                        let newChapter = { visible: false };
                        const previousIndexes = savedChapter ?
                            [
                                ...this.state.previousIndexes,
                                {
                                    id: savedChapter.arcimedes_row_id,
                                    index: savedChapter.index
                                }
                            ] : this.state.previousIndexes;
                        this.setState({
                            chapters: cloneDeep(newChapters),
                            originalChapters: cloneDeep(newChapters),
                            newChapter,
                            previousIndexes,
                            originalVideoLink: this.state.videoLink,
                            error: null
                        },
                            this.toggleEdit
                        );
                        return;
                    }
                    this.setState({
                        error: res && res.data && res.data.createOrUpdateTraining.message
                            ? res.data.createOrUpdateTraining.message
                            : "Unspecified error",
                    });
                }).catch(error => {
                    console.error("Error managing training data:", error);
                    this.setState({ error: "Error managing training data" });
                });
            }
        else if (!newChapter || isEqual(this.state.originalChapters, chapters))
            this.toggleEdit();
    }

    handleInputBlur(key, value, isNewChapter = false) {
        let chapters = cloneDeep(this.state.chapters);
        if (!isNewChapter) {
            const id = key.split('_')[0];
            const newKey = key.split('_')[1];
            const newValue = Number(value);
            let previousIndexes = cloneDeep(this.state.previousIndexes)
            let currentChapterInfo = previousIndexes.find((ch) => ch.id === id);
            const previousIndex = currentChapterInfo.index;

            if (newKey === 'index' && previousIndex && newValue !== previousIndex) {
                chapters.filter((ch) => ch.id !== id).map((chapter) => {
                    if (chapter.index <= newValue && chapter.index > previousIndex) {
                        chapter.index--;
                        previousIndexes.find((o) => o.id === chapter.id).index = chapter.index;
                    }
                    else if (chapter.index >= newValue && chapter.index < previousIndex) {
                        chapter.index++;
                        previousIndexes.find((o) => o.id === chapter.id).index = chapter.index;
                    }
                })
                chapters = sortArray(chapters, 'index');
                currentChapterInfo.index = newValue;
                previousIndexes = [...previousIndexes.filter(ch => ch.id !== id), currentChapterInfo]
                this.setState({ chapters, previousIndexes });
            }
        }
    }

    handleInputChange(key, value, isNewChapter = false) {
        if (isNewChapter) {
            let newChapter = cloneDeep(this.state.newChapter);
            newChapter[key] = value;
            this.setState({ newChapter })
        } else {
            let chapters = cloneDeep(this.state.chapters);
            const id = key.split('_')[0];
            const newKey = key.split('_')[1];
            let currentChapter = chapters.find((el) => el.id === id);
            if (newKey === 'index') {
                currentChapter[newKey] = Number(value);
            } else
                currentChapter[newKey] = value;
            this.setState({ chapters });
        }
    }

    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        const slug = slugs[slugs.length - 1] || '';
        const parentChapterSlug = slugs[slugs.length - 2] || '';

        // Drop data from the previously shown section while the new one loads.
        if (this.contentRef.current)
            this.contentRef.current.innerHTML = '';
        this.setState({ contentResp: null, nodeLoadedFor: null });
        slugs.pop();
        const parentSlug = slugs.join('/') || 'training';
        let parentChapterParentSlug = ''
        if (slugs.length) {
            slugs.pop();
            parentChapterParentSlug = slugs.join('/') || 'training';
        }
        const hasVideo = parentSlug === 'brokerage-continuum';
        const token = localStorage.getItem('authToken');
        // const requests = [
        //     this.client.query({
        //         query: GET_TRAINING, variables: {
        //             filter: [{ text: '', code: 'DELETED', type: 'null' },
        //             { text: parentSlug, code: 'PARENT_SLUG', type: 'exact' },
        //             { text: slug, code: 'SLUG', type: 'exact' }],
        //             filterType: 'and'
        //         }
        //     }),
        //     this.client.query({
        //         query: GET_TRAINING, variables: {
        //             filter: [{ text: '', code: 'DELETED', type: 'null' },
        //             { text: subchapterParentSlug, code: 'PARENT_SLUG', type: 'exact' }],
        //             filterType: 'and'
        //         }
        //     })
        // ];
        let payloadFilter = {
            "PARENT_SLUG": parentSlug,
            "SLUG": slug
          }
        const requests = [
            //         this.client.query({
            //             query: GET_TRAINING,variables:{filters:payloadFilter},fetchPolicy: "no-cache",
            //             context: {
            //                 headers: {
            //                     authorization: `Bearer ${token}`, // Bearer token added here
            //                 },
            //             }
            // }), 
            fetchData(GET_TRAINING, { filters: payloadFilter }),
            //     this.client.query({
            //         query: GET_TRAINING,variables:{filters:{"PARENT_SLUG": subchapterParentSlug}},fetchPolicy: "no-cache",
            //         context: {
            //             headers: {
            //                 authorization: `Bearer ${token}`, // Bearer token added here
            //             },
            //         }
            // })
            fetchData(GET_TRAINING, { filters: { "PARENT_SLUG": subchapterParentSlug } })
        ]
        if (parentChapterParentSlug){
            let chapterFilter = {
                "PARENT_SLUG": parentChapterParentSlug,
                "SLUG": parentChapterSlug
              }
            requests.push(
                // this.client.query({
                //     query: GET_TRAINING, variables: {
                //         filter: [{ text: '', code: 'DELETED', type: 'null' },
                //         { text: parentChapterParentSlug, code: 'PARENT_SLUG', type: 'exact' },
                //         { text: parentChapterSlug, code: 'SLUG', type: 'exact' }],
                //         filterType: 'and'
                //     }
                // })
                //     this.client.query({
                //         query: GET_TRAINING,variables:{filters:chapterFilter},fetchPolicy: "no-cache",
                //         context: {
                //             headers: {
                //                 authorization: `Bearer ${token}`, // Bearer token added here
                //             },
                //         }
                // })
                fetchData(GET_TRAINING, { filters: chapterFilter })
            )
        }

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data.getTrainingFilter.data && res[1] && res[1].data.getTrainingFilter.data && (res[2] && res[2].data.getTrainingFilter.data || !res[2])) {
                const chapters = sortArray(
                    res[1].data.getTrainingFilter.data.map((chapter) => {
                        return {
                            id: chapter.ARCIMEDES_ROW_ID,
                            slug: chapter.SLUG,
                            title: chapter.NAME,
                            index: parseInt(chapter.INDEX),
                            img: chapter.PHOTO ? chapter.PHOTO : null,
                            imagePath: chapter.IMAGEPATH || null
                        }
                    }), 'index');

                let previousIndexes = [];
                chapters.map((ch) => {
                    const id = ch.id;
                    const index = ch.index;
                    previousIndexes.push({ id, index });
                })
                this.setState({
                    originalChapters: cloneDeep(chapters),
                    chapters,
                    previousIndexes,
                    title: res[0].data.getTrainingFilter.data[0].NAME || '',
                    hasVideo,
                    videoLink: res[0].data.getTrainingFilter.data[0].VIDEO_LINK || '',
                    backButton: res[2] ? res[2].data.getTrainingFilter.data[0].NAME : 'TRAINING',
                    nodePhoto: res[0].data.getTrainingFilter.data[0].PHOTO || null,
                    nodeName: res[0].data.getTrainingFilter.data[0].NAME || '',
                    nodeImagePath: res[0].data.getTrainingFilter.data[0].IMAGEPATH || null,
                    nodeId: res[0].data.getTrainingFilter.data[0].ARCIMEDES_ROW_ID || null,
                    originalVideoLink: res[0].data.getTrainingFilter.data[0].VIDEO_LINK || '',
                    nodeLoadedFor: subchapterParentSlug,
                }, this.maybeMigrateContent);
            }
        });

        // Load this section's own content: a section holding both content and sub-tiles gets
        // its content migrated into a tile (see maybeMigrateContent); until then it is shown
        // above the tiles so nothing is lost.
        fetchData(GET_TRAINING_CONTENT, { filters: { "CHAPTER_SLUG": subchapterParentSlug } }).then(res => {
            const contentData = res && res.data && res.data.getTrainingContentFilter && res.data.getTrainingContentFilter.data;
            const contentResp = Array.isArray(contentData) && contentData[0] ? contentData[0] : null;
            if (this.contentRef.current)
                this.contentRef.current.innerHTML = contentResp && contentResp.CONTENT ? contentResp.CONTENT : '';
            this.setState({ contentResp }, this.maybeMigrateContent);
        }).catch(error => {
            console.error("Error fetching training content:", error);
        });
    }

    cancelChanges() {
        const original = cloneDeep(this.state.originalChapters);
        if (newChapter && newChapter.visible)
            this.removePhoto();

        const newChapter = { visible: false };
        this.setState({ chapters: original, newChapter, videoLink: this.state.originalVideoLink }, this.toggleEdit);
    }

    uploadPhoto(id) {
        const fileName = this.state.uploadedImage.name;
        const base64File = this.state.uploadedImage.base64;
        return uploadFile({ fileName, base64File, folder: FOLDER }).then(res => {
            //res = res.data.responses[0];
            res = res.data.uploadImage;
            if (!res || !res.success) {
                if (res.errorCode === existingFileError) {
                    this.setState({
                        uploadedImage: null,
                        error: existingFileErrorMessage
                    });
                } else {
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            } else {
                if (!id) {
                    const newChapter = { ...this.state.newChapter }
                    newChapter.img = res.fileUrl.fileUrl;
                    newChapter.imageAddress = res.fileUrl.s3_url;
                    newChapter.imagePath = res.fileUrl.s3_url;
                    this.setState({ newChapter, error: null });
                } else {
                   
                    let chapters = this.state.chapters;
                    let currentChapter = chapters.find((el) => el.id === id);
                    //currentChapter.img = arc.path.media + res.data.url.split('/v0/')[1];
                    currentChapter.img = res.fileUrl.fileUrl;
                    currentChapter.imageAddress = res.fileUrl.s3_url;
                    currentChapter.imagePath = res.fileUrl.s3_url;
                    //currentChapter.img = base64File;
                    this.setState({ chapters, error: null });
                }
            }
        })
    }
    deleteCard(id) {
        let chapters = cloneDeep(this.state.chapters);
        chapters = chapters.filter((e) => e.id != id);
        this.setState({ chapters });
    }

    removePhoto(id) {
        let chapter = {};
        let chapters = cloneDeep(this.state.chapters)

        if (id)
            chapter = chapters.find((ch) => ch.id === id);
        const fileName = id ? (chapter.imagePath ? chapter.imagePath : null) : this.state.newChapter.imageAddress;
        let newChapter = cloneDeep(this.state.newChapter);
        if (fileName)
            removeFile(fileName).then(res => {
                if (!res || !res.data.deleteImage.success) {
                    if (res.errorCode === missingFileError) {
                        if (!id) {
                            newChapter.img = null;
                            this.setState({
                                uploadedFile: null,
                                newChapter
                            });
                        }
                        else {
                            chapter.img = null;
                            this.setState({
                                chapters,
                                error: 'File not found.'
                            });
                        }
                    } else {
                        this.setState({
                            error: res && res.data.deleteImage.message ? res.data.deleteImage.message : "Unspecified error",
                        });
                    }
                } else {
                    if (!id) {
                        newChapter.img = null;
                        this.setState({
                            uploadedFile: null,
                            newChapter,
                            error: null
                        });
                    } else {
                        let chapters = this.state.chapters;
                        let chapter = chapters.find(el => el.id === id)
                        chapter.img = null;

                        // manageData({
                        //     tableCode: TRAINING,
                        //     data: [{
                        //         ARCIMEDES_ROW_ID: chapter.id,
                        //         PHOTO: null,
                        //         NAME: chapter.title,
                        //         INDEX: chapter.index,
                        //         SLUG: chapter.slug
                        //     }]
                        // })
                        const token = localStorage.getItem('authToken');
                        let payload=[{
                            "arcimedes_row_id": chapter.id,
                            "slug":chapter.slug,
                            "index": chapter.index,
                            "photo": null,
                            "name": chapter.title
                          }]
                    //     this.client.mutate({
                    //     //({mutation:TRAINING, variables:{data:[{ARCIMEDES_ROW_ID: chapter.id,PHOTO: null,NAME: chapter.title,INDEX: chapter.index,SLUG: chapter.slug}]}})
                    //     mutation: TRAINING,
                    //     variables: { input: payload },
                    //     fetchPolicy: "no-cache",
                    //     context: {
                    //       headers: {
                    //         authorization: `Bearer ${token}`,
                    //       },
                    //     },
                    //   })
                      mutateData(TRAINING, { input: payload })
                        .then(res => {
                            if (res && res.data && res.data.createOrUpdateTraining) {
                                this.setState({ chapters, error: null });
                                return;
                            }
                            this.setState({
                                error: res && res.data && res.data.createOrUpdateTraining.message
                                ? res.data.createOrUpdateTraining.message
                                : "Unspecified error",
                            });
                        }).catch(error => {
                            console.error("Error saving chapter:", error);
                            this.setState({ error: "Error saving chapter" });
                        });
                    }
                }
            });
    }

    validateSelectedFile(event, id) {
        let selectedFile = event.currentTarget.files[0];
        const fileSize = selectedFile.size / 1000000; //mb

        if (fileSize > 20) {
            this.setState({ error: 'Maximum file size exceeded' });
            return;
        }
        getBase64(selectedFile).then(result => {
            selectedFile["base64"] = result;
            this.setState({uploadedImage: selectedFile}, () => id ? this.uploadPhoto(id) : this.uploadPhoto());
        });
    }

    getFullPathSlug() {
        const params = this.props.params || {};
        const keys = Object.keys(params);
        const slugs = keys.length ? keys.map(key => params[key]) : [];
        return slugs.join('/');
    }

    canEditContent() {
        // Admins can restructure content into tiles across all training modules.
        return this.props.isSuper;
    }

    // A section that has both its own content and sub-tiles shows tiles only: the content is
    // moved into its own "content tile" (same image/title), whose details page holds the text.
    // Runs once, when an admin opens a legacy mixed section.
    maybeMigrateContent() {
        const { contentResp, nodeName, nodeImagePath, chapters, nodeLoadedFor } = this.state;
        if (this.migrating) return;
        if (!this.canEditContent()) return;
        if (!contentResp || !(contentResp.CONTENT || contentResp.PHOTO) || !contentResp.ARCIMEDES_ROW_ID) return;
        if (!nodeName || !chapters.length) return;

        // Only migrate when everything in state was loaded for the page currently shown;
        // during navigation the node info, tiles and content can briefly belong to
        // different sections, which must never be mixed into one migration.
        const path = this.getFullPathSlug();
        if (nodeLoadedFor !== path || contentResp.CHAPTER_SLUG !== path) return;

        this.migrating = true;
        const contentTileSlug = this.getNewSlug(nodeName);
        const moveContentRow = () => {
            mutateData(TRAINING_CONTENT, {
                input: [{
                    arcimedes_row_id: contentResp.ARCIMEDES_ROW_ID,
                    chapter_slug: `${path}/${contentTileSlug}`
                }]
            }).then(() => {
                this.migrating = false;
                this.fetch(this.props.params);
            }).catch(error => {
                console.error("Error moving training content:", error);
                this.migrating = false;
            });
        };

        // If the content tile already exists (e.g. a previous partial migration), just move the row.
        if (chapters.some(ch => ch.slug === contentTileSlug)) {
            moveContentRow();
            return;
        }

        const input = [{
            parent_slug: path,
            slug: contentTileSlug,
            name: nodeName,
            photo: contentResp.PHOTO || nodeImagePath || null,
            index: 1,
        }];
        // Shift the existing tiles down so the content tile comes first.
        chapters.forEach(ch => {
            input.push({ arcimedes_row_id: ch.id, index: parseInt(ch.index) + 1 });
        });
        mutateData(TRAINING, { input }).then(res => {
            if (res && res.data && res.data.createOrUpdateTraining && res.data.createOrUpdateTraining.success) {
                moveContentRow();
                return;
            }
            this.migrating = false;
        }).catch(error => {
            console.error("Error creating content tile:", error);
            this.migrating = false;
        });
    }

    getLoggedInUserEmail() {
        if (this.props.userData && this.props.userData.email)
            return this.props.userData.email;
        const storedUserData = sessionStorage.getItem('userData');
        if (storedUserData) {
            try {
                const parsed = JSON.parse(storedUserData);
                return parsed && parsed.email;
            } catch (e) {
                return null;
            }
        }
        return null;
    }

    render() {
        const { isSuper } = this.props;
        const { chapters, title, hasVideo, videoLink, backButton, isEdit, newChapter, error, contentResp, nodePhoto } = this.state;
        const canDelete = isAuthorizedForTrainingDelete(this.getLoggedInUserEmail());
        const hasContent = contentResp && (contentResp.CONTENT || contentResp.PHOTO);
        // Fallback view for a section that still holds its own content (shown until an admin
        // opens the page and the content is migrated into its own tile).
        const contentImage = hasContent ? (contentResp.PHOTO || nodePhoto) : null;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client
                    }
                    return (
                        <div className='ChapterPage'>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container'>
                                    <div className='page-back-button' onClick={() => { history.back() }}>
                                        <Icon svg={svgSortAsc} />
                                        {backButton}
                                    </div>
                                    <div className='page-header'>
                                        <div className='page-title'>{title}</div>
                                        {
                                            isSuper && isEdit &&
                                            <React.Fragment>
                                                <div className='button-new negative' onClick={this.cancelChanges}>Cancel</div>
                                                <div className='button-new positive' onClick={this.saveChanges}>Save</div>
                                            </React.Fragment>
                                        }
                                        {
                                            isSuper && !isEdit &&
                                            <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
                                        }
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='chapter-content-container'>
                                {
                                    contentImage &&
                                    <img src={contentImage} className='content-image' alt='' />
                                }
                                <div ref={this.contentRef} />
                            </div>
                            {
                                hasVideo && isEdit &&
                                <div className='video-link-container'>
                                    <span className='video-link-label'>Video Link:</span>
                                    <Input theme='white'
                                        name='videoLink'
                                        value={videoLink}
                                        placeholder='Leave empty to hide the Video tile'
                                        handleParentChange={(name, value) => this.setState({ videoLink: value })} />
                                </div>
                            }
                            <div className='cards-container'>
                                {
                                    chapters.filter((e) => e.id).map(chapter => (
                                        <SubChapterCard
                                            id={chapter.id}
                                            key={chapter.slug}
                                            img={chapter.img}
                                            title={chapter.title}
                                            index={chapter.index}
                                            link={`${this.props.location.pathname}/${chapter.slug}`}
                                            handleParentChange={this.handleInputChange}
                                            handleParentBlur={this.handleInputBlur}
                                            isEdit={isEdit}
                                            error={error}
                                            canDelete={canDelete}
                                            deleteCard={(id) => this.deleteCard(id)}
                                            validateSelectedFile={this.validateSelectedFile}
                                            removePhoto={(id) => this.removePhoto(id)}
                                        />
                                    ))
                                }
                                {
                                    hasVideo && !isEdit && videoLink && videoLink.trim() !== '' &&
                                    <SubChapterCard
                                        key='video'
                                        img={arc.path.media + videoImage}
                                        title='Video'
                                        link={videoLink}
                                        newWindow
                                    />
                                }
                                {isEdit &&
                                    <SubChapterCard
                                        isNewChapter={true}
                                        newChapter={newChapter}
                                        handleParentChange={this.handleInputChange}
                                        isEdit={isEdit}
                                        error={error}
                                        validateSelectedFile={this.validateSelectedFile}
                                        removePhoto={(id) => this.removePhoto(id)}
                                        deleteCard={(id) => this.deleteCard(id)}
                                        addNewChapter={() => this.setState({ newChapter: { visible: true } })}
                                    />
                                }
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        )
    }
}